// Facebook.js
import React, { useState } from "react";
import LanguageModal from "./LanguageModal";

const App = () => {
  const [showModal, setShowModal] = useState(false);

  const links = {
    en: "https://app.hotelcondesa.com/",
  };

  return (
    <>
      <button
        className="button-styles hover-text"
        onClick={() => setShowModal(true)}
      >
        <span className="tooltip-text" id="fade">App</span>
        <i className="bi bi-app"></i>
      </button>
      {showModal && <LanguageModal title="App" icon="bi bi-app" links={links} onClose={() => setShowModal(false)} />}
    </>
  );
};

export default App;